import { NewsFlatDTO } from "../domain/models/dto/NewsDTO";
import { INewsFlat } from "../domain/models/News";
import { NewsFlatModel } from "../models/NewsFlatModel";
import { FileMapper } from "./FileMapper";
import { SimpleMapper } from "./SimpleMapper";

export class NewsFlatMapper extends SimpleMapper<INewsFlat, NewsFlatDTO> {
    protected toDTOFields: string[] = [
        "id",
        "title",
        "content",
        "shortContent",
        "languageCode",
        "files",
    ];
    protected fromDTOFields: string[] = [
        ...this.toDTOFields,
        "updatedAt",
        "createdAt",
        "creatorId",
    ];
    protected entityConstructor = NewsFlatModel;

    private fileMapper = new FileMapper();

    fromDTO(dto: NewsFlatDTO): INewsFlat {
        if (!dto) return null;

        const baseDto = super.fromDTO(dto);
        baseDto.files =
            dto.files?.map((file) => this.fileMapper.fromDTO(file)) ?? [];

        return baseDto;
    }

    toDTO(model: INewsFlat): NewsFlatDTO {
        if (!model) return null;

        const baseDto = super.toDTO(model);
        baseDto.files =
            model.files?.map((file) => this.fileMapper.toDTO(file)) ?? [];

        return baseDto;
    }
}
